
import React, { useState, useContext } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';

import ToolTipWrapper from '../Tooltip/ToolTipWrapper';
import { BuildPath } from  '@/helpers/Paths';
import  SelectUsersOrUserGroupsModal, {ActiveTabs} from  '@/components/modals/SelectUsersOrUserGroupsModal';
import { LockerManagementFileUploadContext, SearchType } from '@/context/LockerManagementFileUploadContext';

const SelectUserGroupsAndUsers = () => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [defaultModalTab, setDefaultModalTab] = useState<ActiveTabs>(ActiveTabs.USERS)

    const {selectedGroups, selectedUsers, removeAll} = useContext(LockerManagementFileUploadContext)

    function InfoPill({value, type}:{value: any[],type: SearchType }): JSX.Element {
        return (
            <span className="pill">
                <button
                    className="pill-link-button"
                    onClick={() => {
                        setShowModal(true)
                        setDefaultModalTab(type === SearchType.USER ? ActiveTabs.SELECTEDUSERS : ActiveTabs.SELECTEDGROUPS) 
                    }}
                >
                    {value.length} {type === SearchType.USER ? 'User' : 'User Group'}{value.length > 1 ? 's' : ''} Selected
                </button>
                <button 
                    className="pill-cancel-button"
                    onClick={() => {
                        removeAll(type);
                    }}
                    aria-label={`remove all ${type === SearchType.USER ? 'User' : 'User Group'}s`}
                >
                    <img src={`${BuildPath()}/images/buttons/close-modal-blue.svg`}/>
                </button>
            </span>
        )
    }

    function PillContainer(): JSX.Element {
        return (
            <div className={'pill-container'}>
                {!!selectedUsers.length && <InfoPill value={selectedUsers} type={SearchType.USER}/> }
                {!!selectedGroups.length && <InfoPill value={selectedGroups} type={SearchType.GROUP} /> }
            </div>
        )
    }
        
   
    
    return (
        <section className="select-user-groups-and-users">
            <div className="header">
                <div className="header-title">
                    <h3>Select User Groups/Users</h3>
                    <ToolTipWrapper id="highlight-tooltip-select-user" className="tracks-side-tooltip">
                        <ReactTooltip id="highlight-tooltip-select-user" place="top" className='thrive-tooltip' delayHide={1000} >
                            <span>Choose which user(s) and user group(s) to send this batch to</span>
                        </ReactTooltip>
                    </ToolTipWrapper>
                </div>
                <button className="search-button" onClick={() => setShowModal(true) }>      
                    Search/Select
                </button>
            </div>
            { !selectedGroups.length && !selectedUsers.length 
                ?  <p className='placeholder-text'>Please select a user(s) or a user group(s) to upload this batch into Locker</p>
                : <PillContainer />
            }
            <SelectUsersOrUserGroupsModal 
                show={showModal}
                onClose={() => setShowModal(false)}
                className="select-users-or-user-groups-modal"
                defaultTab={defaultModalTab}
                setDefaultTab={setDefaultModalTab}
            />
        </section>
    )
}

export default SelectUserGroupsAndUsers